import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import { ContentTitle } from '../../../components/utilities/styledComponents/ContentTitle';
import Card from '../../../components/Card';
import iconMegaphone from '../../../img/megaphone.svg';
import FormCampaignPosting from '../../../components/FormCampaignPosting';
import { LoaderMain } from '../../../components/Loader';

export default class CampaignPosting extends Component {
	constructor(props) {
		super(props);

		this.state = {
			demandId: 0,
		};
	}

	componentDidMount() {
		const { match } = this.props;
		this.setState({
			demandId: match.params.demandId,
		});
	}

	render() {
		const { history } = this.props;
		const { demandId } = this.state;

		return (
			<Fragment>
				<ContentTitle className="d-flex justify-content-between">
					Publicação de campanha
				</ContentTitle>

				<Link
					className="btn btn-outline-secondary border-0 btn-sm m-4"
					to={history.location.pathname}
					onClick={history.goBack}
				>
					{'< Voltar para demanda'}
				</Link>

				<div className="container-fluid mb-4">
					<div className="row">
						<div className="col-12">
							{!demandId ? (<LoaderMain />) : (
								<Card
									icon={iconMegaphone}
									title="Publicação de campanha"
									titleIcon="Publicação de campanha"
								>
									<FormCampaignPosting
										demandId={demandId}
									/>
								</Card>
							)}
						</div>
					</div>
				</div>
			</Fragment>
		);
	}
}
